import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.auth, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_USER_TYPE}_SUCCESS`:
      return _assign({}, state, { initUserDetails: action.payload });
    case `${ActionTypes.GET_HACKER}_SUCCESS`:
      return _assign({}, state, action.payload);
    case `${ActionTypes.GET_RECRUITER}_SUCCESS`:
      return _assign({}, state, action.payload);
    case `${ActionTypes.AUTH}_FAIL`:
      return _assign({}, state, {
        appHasError: true,
        appError: action.error,
      });
    default:
      return state;
  }
};
